import {
  ChangeToAdminButton,
  ChangeToMemberButton,
  AuthorityToolTip,
} from "@/components/atoms";
import { AuthorityDisplayNameMap } from "@/models";
import { Authority } from "@/generated/graphql";
import { useIsSpMode } from "@/hooks";
import { css } from "@emotion/react";
import { Button, Font } from "@moneyforward/mfx_biz_react_components";
import { useRouter } from "next/router";
import { color } from "@/styles/theme";

type Props = {
  authority: Authority;
  waitingForChangeToAdmin: boolean;
  onClickChangeToMember: () => void;
  onClickChangeToAdmin: () => void;
  onClickResendEmail?: () => void;
  loading: boolean;
  meIsAdminUsersAtMikatanoID?: boolean;
  userIsAdminUsersAtMikatanoID?: boolean;
};

export const AuthorityBlock = ({
  authority,
  waitingForChangeToAdmin,
  onClickChangeToAdmin,
  onClickChangeToMember,
  onClickResendEmail,
  loading,
  meIsAdminUsersAtMikatanoID,
  userIsAdminUsersAtMikatanoID,
}: Props) => {
  const isSpMode = useIsSpMode();
  const router = useRouter();

  const displayName = waitingForChangeToAdmin
    ? "一般(管理者メール未認証)"
    : AuthorityDisplayNameMap.get(authority);

  const changeAuthorityButton =
    authority === Authority.Admin ? (
      <ChangeToMemberButton
        onClick={onClickChangeToMember}
        loading={loading}
        userIsAdminUsersAtMikatanoID={userIsAdminUsersAtMikatanoID}
      />
    ) : (
      <ChangeToAdminButton onClick={onClickChangeToAdmin} loading={loading} />
    );

  const emailResendButton = (
    <Button
      type="button"
      variant="secondary"
      onClick={onClickResendEmail}
      disabled={loading}
    >
      メール再送
    </Button>
  );

  const button = waitingForChangeToAdmin
    ? emailResendButton
    : changeAuthorityButton;

  return (
    <div css={!isSpMode ? container : {}}>
      <div css={labelWrapper}>
        <Font variant="m" component="p" css={toolTip}>
          権限
          <AuthorityToolTip />
        </Font>
      </div>
      <div css={authWrapper}>
        <div css={inputWrapper}>
          <Font variant="m" component="span" css={authorityName}>
            {displayName}
          </Font>
          {button}
        </div>
        {userIsAdminUsersAtMikatanoID && (
          <>
            {meIsAdminUsersAtMikatanoID ? (
              <Font css={gray}>
                ※権限を一般へ変更する場合は先に
                {
                  <span
                    css={linkButton}
                    onClick={() => router.push("/contract-management?tab=2")}
                  >
                    契約管理者一覧
                  </span>
                }
                から削除してください。
              </Font>
            ) : (
              <Font css={gray}>
                ※契約管理者のため、一般へ変更することができません。
              </Font>
            )}
          </>
        )}
      </div>
    </div>
  );
};

const container = css({
  display: "flex",
});

const labelWrapper = css({
  width: "200px",
  marginRight: "15px",
  paddingTop: "5px",
  paddingBottom: "4px",
});

const inputWrapper = css({
  display: "flex",
  alignItems: "center",
});

const authorityName = css({
  marginRight: "10px",
});

const toolTip = css({
  display: "flex",
  alignItems: "center",
});

const authWrapper = css({
  width: "100%",
});

const gray = css({
  color: color.gray600,
});

const linkButton = css({
  color: color.link,
  whiteSpace: "nowrap",
  "&:hover": {
    cursor: "pointer",
    textDecoration: "underline",
  },
});
